import React, { useState, useEffect } from 'react'
import { Button, Select, Spin, Input, Space, InputNumber, Upload, message } from 'antd'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ArrowLeftOutlined, UploadOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'
import { productCategories, productStatus, productSizes } from '../../constants/store'

const { TextArea } = Input
const { Option } = Select

function AddProducts() {
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')

  const [allRequestCompleted, setAllRequestCompleted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingTwo, setLoadingTwo] = useState(false)
  const [organizations, setOrganizations] = useState([])
  const [product, setProduct] = useState({})
  const [selectedOrg, setSelectedOrg] = useState([])
  const [attachments, setAttachments] = useState([]) // useable only during edit
  const [removedVideoNames, setRemovedVideoNames] = useState([]) // useable only during edit
  const auth = useSelector((state) => state.auth)
  const [form, setForm] = useState({
    name: '',
    description: '',
    requiredPoints: 0,
    category: '',
    sizes: [],
    disabled: false,
  })

  const onChange = (obj) => {
    // console.log(obj)
    setForm((prev) => ({ ...prev, ...obj }))
  }

  const handleChange = (values) => {
    setSelectedOrg(values)
  }

  const getMyInfo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/me`)

      // Check the admin organizations
      if (response?.data?.user?.organizations && response?.data?.user?.organizations.length > 0) {
        const org = response.data.user.organizations
        // console.log(org)

        // store to render at JSX
        org.forEach((element, idx) => {
          setOrganizations((prevElements) => [
            ...prevElements,
            {
              value: element._id,
              label: element.name,
            },
          ])
        })
      }
      setAllRequestCompleted(true)
      setLoading(false)
    } catch (e) {
      console.log(e)
    }
  }

  const beforeUploadPictureUpload = (file) => {
    const isImage = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'

    const isVideo =
      file.type === 'video/mp4' ||
      file.type === 'video/quicktime' || // .mov
      file.type === 'video/webm'

    if (!isImage && !isVideo) {
      message.error(`${file.name} is not a supported file type. Please upload JPEG, PNG, MP4, MOV, or WEBM.`)
      return Upload.LIST_IGNORE
    }

    const maxSizeMB = isImage ? 5 : 500
    const isWithinLimit = file.size / 1024 / 1024 < maxSizeMB

    if (!isWithinLimit) {
      message.error(`${file.name} must be smaller than ${maxSizeMB}MB!`)
      return Upload.LIST_IGNORE
    }

    // Prevent auto-upload, but still add to fileList
    return false
  }

  const createFocusStack = async () => {
    try {
      // console.log(form)
      // console.log(attachments)

      if (!form.name || !form.description || !form.requiredPoints > 0 || !form.category || !selectedOrg) {
        alert('Please fillup all the fields!')
        return
      }

      if (form.sizes.length == 0) {
        alert(
          'To proceed, a size selection and corresponding quantity are required. If no specific size is applicable, please use the first available size option to input the quantity.'
        )
        return
      }

      setLoading(true)

      const fmData = new FormData()

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: `Bearer ${auth.token}`,
        },
      }

      // return
      attachments?.forEach((element) => {
        fmData.append('attachments', element.originFileObj)
      })
      fmData.append('name', form.name)
      fmData.append('description', form.description)
      fmData.append('requiredPoints', form.requiredPoints)
      fmData.append('category', form.category)
      fmData.append('sizes', JSON.stringify(form.sizes))
      fmData.append('organization', JSON.stringify(selectedOrg))

      // return

      const res = await axios
        .post(`${process.env.REACT_APP_BASE_URL}/api/v1/storeFront/createProduct`, fmData, config)
        .then((res) => {
          //   console.log(res.data)
          navigate(-1)
          // alert('Success')
          // setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
        })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const handleEditProduct = async () => {
    try {
      // console.log(form)
      // console.log(attachments)

      const fields = {
        Name: form.name,
        Description: form.description,
        'Required Points': form.requiredPoints > 0,
        Category: form.category,
        Organization: selectedOrg?.length,
      }

      const missing = Object.entries(fields)
        .filter(([_, value]) => !value)
        .map(([key]) => key)

      if (missing.length) {
        alert(`Please fill up the following fields:\n- ${missing.join('\n- ')}`)
        return
      }

      if (form.sizes.length == 0) {
        alert(
          'To proceed, a size selection and corresponding quantity are required. If no specific size is applicable, please use the first available size option to input the quantity.'
        )
        return
      }

      setLoading(true)

      const fmData = new FormData()

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: `Bearer ${auth.token}`,
        },
      }

      // return

      attachments?.forEach((element) => {
        // Because some could be old editable items which doesn't contain originFileObj
        // Which I don't need to send as file, because they are already uploaded at google and their value stored at mongoDB
        if (element.originFileObj) {
          fmData.append('attachments', element.originFileObj)
        }
      })

      fmData.append('name', form.name)
      fmData.append('description', form.description)
      fmData.append('requiredPoints', form.requiredPoints)
      fmData.append('category', form.category)
      fmData.append('sizes', JSON.stringify(form.sizes))
      fmData.append('disabled', form.disabled)
      fmData.append('organization', JSON.stringify(selectedOrg))
      fmData.append('removedAttachmentNames', JSON.stringify(removedVideoNames))

      // return

      const res = await axios
        .put(`${process.env.REACT_APP_BASE_URL}/api/v1/storeFront/editProduct?docId=${id}`, fmData, config)
        .then((res) => {
          //   console.log(res.data)
          navigate('/manageStore/viewProducts')
          // alert('Success')
          // setLoading(false)
        })
        .catch((err) => {
          setLoading(false)
        })
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const getProducts = async (productId) => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/storeFront/getProducts?productId=${productId}`)

      if (response.data.products.length > 0) {
        const theProduct = response.data.products[0]
        setProduct(theProduct)

        console.log(theProduct)

        setForm((prev) => ({
          ...prev,
          ...{
            name: theProduct.name,
            description: theProduct.description,
            requiredPoints: theProduct.requiredPoints,
            category: theProduct.category,
            disabled: theProduct.disabled,
            sizes: theProduct.sizes,
          },
        }))

        if (theProduct.organization?.length > 0) {
          setSelectedOrg(theProduct.organization)
        }

        // Creating this structure because and desgin upload component, requires this one to preview image thumbnail and proper name
        const formattedAttachments = theProduct.attachments.map((file, index) => ({
          ...file, // keep all original properties
          uid: file.id || `-${index}`, // AntD requires a unique uid
          // name: file.originalname || `file-${index}`, // displayed name with fallback name  // ! Don't use this, for this image deletion doesn't work on edit more
          status: 'done', // show as uploaded ( because Kamal is prefilling this for edit mode )
          url: file.mediaLink, // preview image in small thumbnail
          type: file.contentType, // content type just adding incase if needed
        }))
        setAttachments(formattedAttachments)
      }

      setLoading(false)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    getMyInfo()
  }, [])

  useEffect(() => {
    if (allRequestCompleted && id) {
      console.log('Now query for the editable product.')
      getProducts(id)
    }
  }, [id, allRequestCompleted])

  // If edit mode and the product is still not loaded then keep the jsx in loading state
  if (id && Object.keys(product).length == 0) {
    return (
      <Layout>
        <Spin size="large" />
      </Layout>
    )
  }

  return (
    <Layout>
      {!id && (
        <Button
          onClick={() => {
            navigate(-1)
          }}
        >
          Back
        </Button>
      )}

      <h2>Product Management</h2>

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spin size="large" />
        </div>
      )}

      {organizations.length > 0 && (
        <div style={{ marginBottom: 10 }}>
          <p>Choose organization</p>
          <Select
            mode="multiple"
            placeholder="Please select club or business"
            style={{
              width: 250,
              marginRight: 10,
            }}
            onChange={handleChange}
            options={organizations}
            defaultValue={organizations
              ?.filter((el) => selectedOrg.some((obj) => obj === el.value))
              .map((el) => {
                return {
                  label: el.label,
                  value: el.value,
                }
              })}
          />
        </div>
      )}

      {allRequestCompleted && (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
          <Input
            style={{ width: 200 }}
            placeholder="Product name"
            defaultValue={product.name}
            onChange={async (e) => {
              onChange({ name: e.target.value })
            }}
          />
          <Input.TextArea
            rows={4}
            style={{ width: 200, marginTop: 10 }}
            defaultValue={product.description}
            placeholder="Description"
            onChange={async (e) => {
              onChange({ description: e.target.value })
            }}
          />
          <InputNumber
            placeholder="Points (Max:1000000000 or 1 billion,  Min:1)"
            min={1}
            max={1000000000}
            defaultValue={product.requiredPoints}
            onChange={(val) => {
              onChange({ requiredPoints: val })
            }}
            style={{ marginTop: 10, minWidth: '30%' }}
          />
          <Select
            placeholder="Select category"
            style={{ width: 300, marginTop: 10 }}
            defaultValue={product.category}
            onChange={(value) => {
              onChange({ category: value }) // "value" is integer
            }}
            options={productCategories}
          />

          {/* On edit mode allow the user to disable the product from store */}
          {id && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ color: '#c4c4c4' }}>Change "Disable" status below ("True" will hide the product from users at Growdie app): </span>
              <Select
                placeholder="Choose status"
                style={{ width: 300, marginTop: 10 }}
                defaultValue={product.disabled}
                onChange={(value) => {
                  onChange({ disabled: value })
                }}
                options={productStatus}
              />
            </div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ color: '#c4c4c4' }}>Choose product sizes below (keeping it empty will show nothing in the Growdie app):</span>

            <Select
              mode="multiple"
              placeholder="Choose sizes"
              style={{ minWidth: 500, marginTop: 10 }}
              defaultValue={product.sizes?.map((s) => s.size)}
              onChange={(selectedSizes) => {
                const updatedSizes = selectedSizes.map((size) => {
                  // if size already exists in form, keep its quantity
                  const existing = form.sizes.find((s) => s.size === size)
                  return { size, quantity: existing ? existing.quantity : 0 }
                })
                setForm((prev) => ({ ...prev, sizes: updatedSizes }))
              }}
              options={productSizes}
            />

            {form.sizes?.map((s, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', marginTop: 5 }}>
                <span style={{ width: 50 }}>{s.size}</span>
                <input
                  type="number"
                  min={0}
                  value={s.quantity}
                  style={{ marginLeft: 10, width: 80 }}
                  onChange={(e) => {
                    const newQty = parseInt(e.target.value) || 0
                    const newSizes = [...form.sizes]
                    newSizes[idx].quantity = newQty
                    setForm((prev) => ({ ...prev, sizes: newSizes }))
                  }}
                />
              </div>
            ))}
          </div>

          <Upload.Dragger
            style={{ width: 300 }}
            name="logo"
            listType="picture"
            maxCount={5}
            // customRequest={uploadProfilePicture} // Don't use this function immediately after something gets selected
            beforeUpload={beforeUploadPictureUpload}
            onChange={({ fileList }) => {
              console.log(fileList)

              const missingInVideo2 = attachments.filter((v1) => !fileList.some((v2) => v2.name === v1.name)) // This is to find out the "name" of the video

              if (missingInVideo2.length) {
                setRemovedVideoNames((prev) => [...prev, missingInVideo2[0]?.name]) // to send at backend
              }

              setAttachments(fileList)
            }}
            fileList={attachments}
            accept="image/jpeg,image/jpg,image/png,video/mp4,video/quicktime,video/webm"
          >
            <Button type="text" icon={<UploadOutlined />}>
              Click to upload or drag here
            </Button>
          </Upload.Dragger>

          <Button
            type="primary"
            disabled={loading}
            loading={loading}
            onClick={() => {
              if (!id) {
                createFocusStack()
              } else {
                handleEditProduct()
              }
            }}
          >
            {!id ? 'Create' : 'Update'}
          </Button>
        </Space>
      )}
    </Layout>
  )
}

export default AddProducts
